import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { ChatData, GenesysChatService } from '@shared/services/genesys-chat.service';
import { Angulartics2Segment } from 'angulartics2';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'ten-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, MatLegacyButtonModule, MatIconModule, MatLegacyProgressSpinnerModule],
})
export class ChatComponent implements OnInit, OnDestroy {
  @Input() public genesysWebMessengerEnabled = false;
  @Input() public genesysChatData: ChatData;

  public open = false;
  public bellInited = false;
  public chatConnected = false;

  private destroy$ = new Subject<void>();
  public chatLoading: boolean;

  constructor(
    private genesysChatService: GenesysChatService,
    private angulartics2Segment: Angulartics2Segment,
    private cd: ChangeDetectorRef
  ) {}

  public ngOnInit() {
    if (this.genesysWebMessengerEnabled) {
      this.genesysChatService.opened$.subscribe((opened) => {
        this.open = opened;
        this.cd.markForCheck();
      });

      if (this.genesysChatService.restoreOpen(this.genesysChatData.deploymentId)) {
        this.genesysChatService.open(this.genesysChatData);
      }
    }
  }

  public ngOnDestroy() {
    if (this.genesysWebMessengerEnabled && this.open) {
      this.genesysChatService.closeChat();
    }
    this.destroy$.next();
  }

  public showWindow() {
    if (this.genesysWebMessengerEnabled) {
      this.genesysChatService.chatLoading$.pipe(takeUntil(this.destroy$)).subscribe(() => (this.chatLoading = true));
      this.genesysChatService.chatReady$.pipe(takeUntil(this.destroy$)).subscribe(() => (this.chatLoading = false));
      this.genesysChatService.open(this.genesysChatData);
    }
    this.angulartics2Segment.eventTrack('Webchat bell clicked', Date.now());
  }

  public closeWindow() {
    this.open = false;
  }
}
